<script>
import TextHighlighter from 'design-system/components/Text/TextHighlighter';

/**
 * This component adds two main items to TextHighlighter:
 * 1) It ignores leading/trailing spaces (trim)
 * 2) It adds the option to truncate the content to keep the search result "in view"
 */
export default {
    extends: TextHighlighter,
    props: {
        /**
         * Whether to truncate the content to focus the search result
         */
        truncate: Boolean,

        /**
         * What length to target (length of viewable text)
         */
        truncateLength: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        showTruncated() {
            return this.showHighlight && this.truncate;
        },

        truncateOverage() {
            const { prefixEnd, highlight, truncateLength } = this;

            if (truncateLength > 0 && prefixEnd + highlight.trim().length > truncateLength) {
                const overage = (prefixEnd + highlight.length) - truncateLength;

                return Math.max(overage, truncateLength / 2);
            }

            return 0;
        },

        suffixStart() {
            const { highlight, prefixEnd } = this;

            return prefixEnd > -1 ? prefixEnd + highlight.trim().length : -1;
        },

        prefixEnd() {
            return this.highlight && this.content ? this.content.trim().toLowerCase().indexOf(this.highlight.trim().toLowerCase()) : -1;
        },

        prefixValue() {
            const {
                content,
                prefixEnd,
                truncate,
                truncateOverage,
            } = this;

            if (!truncate || truncateOverage === 0) {
                return prefixEnd > 0 ? content.substring(0, prefixEnd) : '';
            }

            return content.substring(truncateOverage, prefixEnd);
        },

        matchingValue() {
            const { content, prefixEnd, suffixStart } = this;

            return prefixEnd > -1 && suffixStart > -1 ? content.substring(prefixEnd, suffixStart) : '';
        },
    },
};
</script>

<style lang="scss" scoped>
span {
    line-height: unset;
}

.matching {
    color: $color-blue;
}
</style>
